import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Page from 'src/components/Page';
import { useTranslation } from 'react-i18next';
import { createAgentAction } from 'src/store/actions/catalogActions';
import AgentsList from './AgentList';
import AgentForm from './AgentForm';
import Toolbar from '../Toolbar';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const AgentsListView = () => {
  const { classes }  = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  const handleClose = useCallback(() => {
    setOpen(false);
    setData(null);
  }, [setOpen, setData]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleCreate = useCallback(
    values => {
      delete values.serviceId;
      dispatch(createAgentAction(values));
      handleClose();
    },
    [handleClose]
  );

  return (
    <Page className={classes.root} title={t('NAVIGATION.CATALOG_LIST.AGENT')}>
      <Container maxWidth={false}>
        <Toolbar
          catalogLabel={t('NAVIGATION.CATALOG_LIST.AGENT')}
          handleOpen={handleOpen}
        />
        <Box mt={3}>
          <AgentsList />
        </Box>
      </Container>
      <AgentForm
        open={open}
        data={data}
        handleClose={handleClose}
        handleCreate={handleCreate}
      />
    </Page>
  );
};

export default AgentsListView;
